module.exports = function() {
  return new Worker(__webpack_public_path__ + "80e89329cba3e711e550.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/workers/elementsSave.worker.js
// module id = 451
// module chunks = 1